<template>
  <etapa-formulario>
    <div
      class="dados-stepper"
      role="navigation"
      aria-label="Passos da aba Dados"
    >
      <dados-progress-header
        :etapa-atual="passoMobile + 1"
        :total-etapas="passosMobile.length"
        :titulo="passosMobile[passoMobile].titulo"
        :preenchidos="totalPreenchidos"
        :total-geral="24"
      />
    </div>

    <div class="dados-passo" :class="{ 'is-ativo': passoMobile === 0 }">
      <div class="dados-passo-header">
        <div class="dados-form-heading" aria-hidden="true">
          <span class="dados-form-heading__marker">1</span>
          <span class="dados-form-heading__copy">
            <strong>5 Campos nesta etapa</strong>
          </span>
          <span class="dados-form-heading__legend"><b>*</b> Obrigatório</span>
        </div>
      </div>

      <secao-formulario
        :icone="false"
        campos-obrigatorios
        rotulo="Veículo e Projeto"
      />

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-6 etapa-formulario__campo--xl-6"
      >
        <campo-selecao
          obrigatorio
          :opcoes="opcoesPlaca"
          :erro="validacao.placa"
          :value="placaSelecionada"
          @input="aoSelecionarPlaca"
          rotulo="Selecione a placa"
          :carregando="carregandoVeiculo"
          placeholder="Selecione uma placa"
          :desabilitado="carregandoVeiculo"
          no-options-text="Nenhuma placa disponível"
          no-result-text="A placa digitada não foi encontrada"
        />
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-6 etapa-formulario__campo--xl-6"
      >
        <campo-selecao
          obrigatorio
          :opcoes="opcoesProjeto"
          :value="projetoSelecionado"
          @input="aoSelecionarProjeto"
          rotulo="Selecione o projeto"
          :carregando="carregandoVeiculo"
          :placeholder="'Selecione um projeto'"
          :desabilitado="carregandoVeiculo || !placaSelecionada"
          :erro="validacao.projeto"
        />
      </div>

      <secao-formulario
        :icone="false"
        campos-obrigatorios
        rotulo="Classificação"
      />

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
      >
        <campo-selecao
          obrigatorio
          rotulo="Tipo de Ocorrência"
          :value="value.tipoOcorrencia"
          :carregando="carregandoOpcoes"
          :desabilitado="
            carregandoOpcoes ||
              carregandoClassificacoes ||
              !campoHabilitado('tipoOcorrencia')
          "
          :opcoes="opcoes.tiposOcorrencia"
          :erro="validacao.tipoOcorrencia"
          :placeholder="'Selecione um tipo de ocorrência'"
          @input="atualizarCampo('tipoOcorrencia', $event)"
        />
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
      >
        <campo-selecao
          obrigatorio
          rotulo="Classificação"
          :opcoes="classificacoes"
          :value="value.classificacao"
          :erro="validacao.classificacao"
          :carregando="carregandoClassificacoes"
          :desabilitado="
            carregandoClassificacoes || !campoHabilitado('classificacao')
          "
          :placeholder="'Selecione uma classificação'"
          @input="atualizarCampo('classificacao', $event)"
          no-options-text="Selecione o tipo de ocorrência primeiro."
        />
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
      >
        <campo-selecao
          obrigatorio
          rotulo="Subclassificação"
          :opcoes="subclassificacoes"
          :value="value.subclassificacao"
          :erro="validacao.subclassificacao"
          :carregando="carregandoSubclassificacoes"
          :desabilitado="
            carregandoSubclassificacoes || !campoHabilitado('subclassificacao')
          "
          :placeholder="'Selecione uma subclassificação'"
          @input="atualizarCampo('subclassificacao', $event)"
          no-options-text="Selecione uma classificação primeiro."
        />
      </div>
    </div>

    <div class="dados-passo" :class="{ 'is-ativo': passoMobile === 1 }">
      <div class="dados-passo-header">
        <div class="dados-form-heading" aria-hidden="true">
          <span class="dados-form-heading__marker">2</span>
          <span class="dados-form-heading__copy">
            <strong>6 Campos nesta etapa</strong>
          </span>
          <span class="dados-form-heading__legend"><b>*</b> Obrigatório</span>
        </div>
      </div>
      <secao-formulario
        :icone="false"
        campos-obrigatorios
        rotulo="Local e momento"
      />

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
      >
        <b-form-group
          :state="validacao.dataOcorrencia ? false : null"
          :invalid-feedback="validacao.dataOcorrencia"
        >
          <template #label>
            <span
              class="dados-ocorrencia__rotulo dados-ocorrencia__rotulo--obrigatorio"
              >Data</span
            >
          </template>

          <date-picker
            format="DD/MM/YYYY"
            value-type="YYYY-MM-DD"
            :placeholder="modoVisualizacao ? '-' : 'DD/MM/YYYY'"
            :value="value.dataOcorrencia"
            :disabled="modoVisualizacao || !campoHabilitado('dataOcorrencia')"
            :disabled-date="desabilitarDataFutura"
            @input="
              modoVisualizacao ? null : atualizarCampo('dataOcorrencia', $event)
            "
          />
        </b-form-group>
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
      >
        <b-form-group
          :state="validacao.horaOcorrencia ? false : null"
          :invalid-feedback="validacao.horaOcorrencia"
        >
          <template #label>
            <span
              class="dados-ocorrencia__rotulo dados-ocorrencia__rotulo--obrigatorio"
              >Hora</span
            >
          </template>

          <date-picker
            type="time"
            format="HH:mm"
            value-type="HH:mm"
            :placeholder="modoVisualizacao ? '-' : 'HH:mm'"
            :value="value.horaOcorrencia"
            :disabled="modoVisualizacao || !campoHabilitado('horaOcorrencia')"
            @input="
              modoVisualizacao ? null : atualizarCampo('horaOcorrencia', $event)
            "
          />
        </b-form-group>
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
      >
        <campo-selecao
          obrigatorio
          rotulo="Município - UF"
          :opcoes="opcoes.cidades"
          :value="value.municipioUf"
          :erro="validacao.municipioUf"
          :carregando="carregandoOpcoes"
          :desabilitado="carregandoOpcoes || !campoHabilitado('municipioUf')"
          :placeholder="'Selecione um município'"
          @input="atualizarCampo('municipioUf', $event)"
        />
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
      >
        <campo-selecao
          obrigatorio
          rotulo="Perímetro"
          :value="value.perimetro"
          :opcoes="opcoes.perimetro"
          :erro="validacao.perimetro"
          :carregando="carregandoOpcoes"
          :desabilitado="carregandoOpcoes || !campoHabilitado('perimetro')"
          :placeholder="'Selecione um perímetro'"
          @input="atualizarCampo('perimetro', $event)"
        />
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
      >
        <campo-selecao
          obrigatorio
          rotulo="Uso do veículo"
          :value="value.usoVeiculo"
          :erro="validacao.usoVeiculo"
          :carregando="carregandoOpcoes"
          :desabilitado="carregandoOpcoes || !campoHabilitado('usoVeiculo')"
          :opcoes="opcoes.naturezaOcorrencia"
          :placeholder="'Selecione um uso do veículo'"
          @input="atualizarCampo('usoVeiculo', $event)"
        />
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
      >
        <campo-selecao
          obrigatorio
          rotulo="Condição clima"
          :value="value.condicaoClima"
          :erro="validacao.condicaoClima"
          :carregando="carregandoOpcoes"
          :desabilitado="carregandoOpcoes || !campoHabilitado('condicaoClima')"
          :opcoes="opcoes.condicaoClimaticaVia"
          :placeholder="'Selecione a condição climatica'"
          @input="atualizarCampo('condicaoClima', $event)"
        />
      </div>
    </div>

    <div class="dados-passo" :class="{ 'is-ativo': passoMobile === 2 }">
      <div class="dados-passo-header">
        <div class="dados-form-heading" aria-hidden="true">
          <span class="dados-form-heading__marker">3</span>
          <span class="dados-form-heading__copy">
            <strong>5 Campos nesta etapa</strong>
          </span>
          <span class="dados-form-heading__legend"><b>*</b> Obrigatório</span>
        </div>
      </div>
      <secao-formulario
        :icone="false"
        campos-obrigatorios
        rotulo="Características da via"
      />

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
      >
        <campo-texto
          obrigatorio
          sufixo="km/h"
          maxlength="3"
          :exibir-aviso-limite="false"
          :value="value.velocidadeVia"
          rotulo="Velocidade Aproximada"
          :erro="validacao.velocidadeVia"
          :disabled="!campoHabilitado('velocidadeVia')"
          @keydown="bloquearTeclasVelocidade"
          @input="atualizarVelocidade($event)"
          :placeholder="'Informe a velocidade na via'"
        />
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
      >
        <campo-selecao
          obrigatorio
          rotulo="Pavimento"
          :value="value.pavimento"
          :erro="validacao.pavimento"
          :carregando="carregandoOpcoes"
          :desabilitado="carregandoOpcoes || !campoHabilitado('pavimento')"
          :opcoes="opcoes.tipoPavimentacao"
          :placeholder="'Selecione um pavimento'"
          @input="atualizarCampo('pavimento', $event)"
        />
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
      >
        <campo-selecao
          obrigatorio
          rotulo="Condição via"
          :value="value.condicaoVia"
          :erro="validacao.condicaoVia"
          :carregando="carregandoOpcoes"
          :desabilitado="carregandoOpcoes || !campoHabilitado('condicaoVia')"
          :opcoes="opcoes.condicaoFisicaVia"
          :placeholder="'Selecione uma condição'"
          @input="atualizarCampo('condicaoVia', $event)"
        />
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-6 etapa-formulario__campo--xl-6"
      >
        <campo-textarea
          obrigatorio
          rotulo="Descrição do local"
          :value="value.descricaoLocal"
          :erro="validacao.descricaoLocal"
          :desabilitado="!campoHabilitado('descricaoLocal')"
          :maxlength="200"
          :minimo="3"
          exibir-contador
          :exibir-aviso-limite="false"
          :placeholder="'Informe a descrição do local'"
          @input="atualizarCampo('descricaoLocal', $event)"
        />
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-6 etapa-formulario__campo--xl-6"
      >
        <campo-textarea
          obrigatorio
          rotulo="Partes avariadas"
          :value="value.partesAvariadas"
          :erro="validacao.partesAvariadas"
          :desabilitado="!campoHabilitado('partesAvariadas')"
          :maxlength="4000"
          :minimo="3"
          exibir-contador
          :exibir-aviso-limite="false"
          :placeholder="'Informe as partes avariadas'"
          @input="atualizarCampo('partesAvariadas', $event)"
        />
      </div>
    </div>

    <div class="dados-passo" :class="{ 'is-ativo': passoMobile === 3 }">
      <div class="dados-passo-header">
        <div class="dados-form-heading" aria-hidden="true">
          <span class="dados-form-heading__marker">4</span>
          <span class="dados-form-heading__copy">
            <strong>4 Campos nesta etapa</strong>
          </span>
          <span class="dados-form-heading__legend"><b>*</b> Obrigatório</span>
        </div>
      </div>
      <secao-formulario
        :icone="false"
        campos-obrigatorios
        rotulo="Informações complementares"
      />

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-6 etapa-formulario__campo--xl-6"
      >
        <campo-selecao
          obrigatorio
          :opcoes="opcoes.booleano"
          :carregando="carregandoOpcoes"
          :value="value.envolvimentoTerceiros"
          rotulo="Teve envolvimento de terceiros?"
          :erro="validacao.envolvimentoTerceiros"
          :desabilitado="
            carregandoOpcoes || !campoHabilitado('envolvimentoTerceiros')
          "
          :placeholder="'Selecione o envolvimento de terceiros'"
          @input="atualizarCampo('envolvimentoTerceiros', $event)"
        />
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-6 etapa-formulario__campo--xl-6"
      >
        <campo-selecao
          obrigatorio
          :opcoes="opcoes.booleano"
          :value="value.adesivo0800"
          :erro="validacao.adesivo0800"
          :carregando="carregandoOpcoes"
          :desabilitado="carregandoOpcoes || !campoHabilitado('adesivo0800')"
          rotulo="Veículo possui adesivo 0800 Unicampo?"
          @input="atualizarCampo('adesivo0800', $event)"
          :placeholder="'Selecione se possui ou não adesivo 0800 Unicampo'"
        />
      </div>

      <transition name="fade">
        <div
          v-if="ativaCampoJustificativaAdesivo"
          class="etapa-formulario__campo etapa-formulario__campo--md-6 etapa-formulario__campo--xl-12"
        >
          <campo-textarea
            :linhas="3"
            rotulo="Se não, justifique"
            obrigatorio
            :value="value.justificativaAdesivo"
            :erro="validacao.justificativaAdesivo"
            :desabilitado="!campoHabilitado('justificativaAdesivo')"
            :maxlength="200"
            :minimo="10"
            exibir-contador
            :exibir-aviso-limite="false"
            :placeholder="'Informe sua justificativa'"
            @input="atualizarCampo('justificativaAdesivo', $event)"
          />
        </div>
      </transition>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-12 etapa-formulario__campo--xl-12"
      >
        <campo-textarea
          :linhas="4"
          obrigatorio
          rotulo="Descreva a ocorrência"
          :value="value.descricaoOcorrencia"
          :erro="validacao.descricaoOcorrencia"
          :desabilitado="!campoHabilitado('descricaoOcorrencia')"
          :maxlength="4000"
          :minimo="20"
          exibir-contador
          :exibir-aviso-limite="false"
          :placeholder="'Descreva a ocorrência'"
          @input="atualizarCampo('descricaoOcorrencia', $event)"
          dica="(Informe detalhes da ocorrência, como por exemplo o que estava
          fazendo previamente ao incidente, qual velocidade e via estava no
          momento da ocorrência, como foi que a mesma ocorreu, etc)"
        />
      </div>
    </div>

    <div class="dados-passo" :class="{ 'is-ativo': passoMobile === 4 }">
      <div class="dados-passo-header">
        <div class="dados-form-heading" aria-hidden="true">
          <span class="dados-form-heading__marker">5</span>
          <span class="dados-form-heading__copy">
            <strong>5 Campos nesta etapa</strong>
          </span>
          <span class="dados-form-heading__legend"><b>*</b> Obrigatório</span>
        </div>
      </div>
      <secao-formulario
        :icone="false"
        campos-obrigatorios
        rotulo="Registro da ocorrência"
      />

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
      >
        <campo-selecao
          obrigatorio
          rotulo="Registrou B.O.?"
          :opcoes="opcoes.booleano"
          :value="value.registrouBo"
          :erro="validacao.registrouBo"
          :carregando="carregandoOpcoes"
          :desabilitado="carregandoOpcoes || !campoHabilitado('registrouBo')"
          @input="atualizarCampo('registrouBo', $event)"
          :placeholder="'Selecione se registrou B.O. ou não'"
        />
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
      >
        <campo-texto
          rotulo="Delegacia"
          :value="value.delegacia"
          :erro="validacao.delegacia"
          :disabled="!campoHabilitado('delegacia')"
          :maxlength="100"
          exibir-contador
          :exibir-aviso-limite="false"
          :placeholder="'Selecione a delegacia'"
          @input="atualizarCampo('delegacia', $event)"
        />
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
      >
        <campo-texto
          :value="value.numeroBo"
          rotulo="Número do B.O ou protocolo"
          :erro="validacao.numeroBo"
          :disabled="!campoHabilitado('numeroBo')"
          :maxlength="30"
          exibir-contador
          :exibir-aviso-limite="false"
          @input="atualizarCampo('numeroBo', $event)"
          placeholder="Informe o número do B.O ou protocolo"
        />
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-6 etapa-formulario__campo--xl-6"
      >
        <campo-selecao
          :opcoes="opcoes.booleano"
          :value="value.contatoTecnico"
          :carregando="carregandoOpcoes"
          :desabilitado="carregandoOpcoes || !campoHabilitado('contatoTecnico')"
          rotulo="Você informou seu Contato Técnico?"
          :placeholder="'Selecione seu Contato Técnico'"
          @input="atualizarCampo('contatoTecnico', $event)"
        />
      </div>

      <div
        class="etapa-formulario__campo etapa-formulario__campo--md-6 etapa-formulario__campo--xl-6"
      >
        <campo-selecao
          :opcoes="opcoes.booleano"
          :value="value.informouLocadora"
          :carregando="carregandoOpcoes"
          :desabilitado="
            carregandoOpcoes || !campoHabilitado('informouLocadora')
          "
          rotulo="Você informou a locadora?"
          :placeholder="'Selecione a locadora'"
          @input="atualizarCampo('informouLocadora', $event)"
        />
      </div>
      <p
        v-if="passoMobile === 4 && !modoVisualizacao"
        class="dados-review-note"
      >
        <i class="mdi mdi-shield-check-outline" aria-hidden="true"></i>
        <span>Você poderá conferir tudo antes de enviar.</span>
      </p>
    </div>
  </etapa-formulario>
</template>

<script lang="js">
import CampoTexto from "../campos/CampoTexto.vue";
import EtapaFormulario from "../EtapaFormulario.vue";
import SecaoFormulario from "../SecaoFormulario.vue";
import CampoSelecao from "../campos/CampoSelecao.vue";
import CampoTextarea from "../campos/CampoTextarea.vue";
import DadosProgressHeader from "../DadosProgressHeader.vue";
import { validarVelocidade } from "../../../domain/validators/velocidade.validator.js";
import { sanitizarVelocidade, bloquearTeclasVelocidade } from "../../masks/velocidade.mask.js";
import { validarTextoObrigatorio, validarSelectObrigatorio, validarTamanhoMaximo } from "../../../domain/validators/helpers.js";
import { validarDataOcorrencia, validarHoraOcorrencia } from "../../../domain/validators/dataHora.validator.js";
import { validarDadosOcorrencia, mensagensDadosOcorrencia } from "../../../domain/validators/dadosOcorrencia.validator.js";

/**
 * Etapa "Dados da Ocorrência" do cadastro de novo relato.
 *
 * Renderiza os campos obrigatórios e opcionais usando os campos reutilizáveis
 * (`campos/`) dentro do scaffold `EtapaFormulario` e valida os obrigatórios
 * antes de emitir `salvar`/`proxima`.
 *
 * A carga de classificações/subclassificações é gerenciada pelo container pai,
 * que repassa os dados via props e recebe eventos quando o usuário altera
 * os campos de tipo/classificação.
 *
 * @prop {Object} value - dados da seção (ocorrencia.dados no container)
 * @prop {Object} opcoes - opções dos selects por grupo da API /opcoes-aviso
 * @prop {Array} opcoesPlaca - opções de placa carregadas pelo container
 * @prop {Array} opcoesProjeto - opções de projeto da placa selecionada
 * @prop {Object|null} placaSelecionada - placa escolhida
 * @prop {Object|null} projetoSelecionado - projeto escolhido
 * @prop {boolean} carregandoVeiculo - indica busca das opções de veículo em andamento
 * @prop {Array} classificacoes - opções de classificação carregadas pelo container
 * @prop {Array} subclassificacoes - opções de subclassificação carregadas pelo container
 * @prop {boolean} carregandoClassificacoes - indica busca em andamento
 * @prop {boolean} carregandoSubclassificacoes - indica busca em andamento
 * @prop {boolean} carregandoOpcoes - indica se as opções de aviso ainda estão sendo carregadas
 *
 * @emits input {Object} seção atualizada a cada campo alterado
 * @emits salvar {Object} quando salvo com obrigatórios preenchidos
 * @emits proxima quando avançado com obrigatórios preenchidos
 * @emits passo-mobile {Object} passo atual do multi-step ({ indice, total })
 * @emits buscar-classificacoes {Object} quando o tipo de ocorrência é alterado
 * @emits buscar-subclassificacoes {Object} quando a classificação é alterada
 * @emits update:placaSelecionada {Object|null} quando a placa é escolhida
 * @emits update:projetoSelecionado {Object|null} quando o projeto é escolhido
 */
export default {
  name: "DadosOcorrencia",

  inject: {
    modoVisualizacao: {
      type: Boolean,
      default: false
    }
  },

  components: {
    CampoSelecao,
    CampoTexto,
    CampoTextarea,
    SecaoFormulario,
    EtapaFormulario,
    DadosProgressHeader
  },

  props: {
    value: {
      type: Object,
      required: true
    },

    opcoes: {
      type: Object,
      default: () => ({})
    },

    /** @type {Array<{value: *, label: string}>} placas disponíveis. */
    opcoesPlaca: {
      type: Array,
      default: () => []
    },

    /** @type {Array<{value: *, label: string}>} projetos da placa selecionada. */
    opcoesProjeto: {
      type: Array,
      default: () => []
    },

    /** @type {Object|null} placa atualmente selecionada. */
    placaSelecionada: {
      type: Object,
      default: null
    },

    /** @type {Object|null} projeto atualmente selecionado. */
    projetoSelecionado: {
      type: Object,
      default: null
    },

    /** Indica se as opções de placa/projeto ainda estão sendo carregadas. */
    carregandoVeiculo: {
      type: Boolean,
      default: false
    },

    /** Indica se as opções de aviso (opcoes) ainda estão sendo carregadas. */
    carregandoOpcoes: {
      type: Boolean,
      default: false
    },

    /** @type {Array<{value: string, label: string}>} classificações do tipo selecionado. */
    classificacoes: {
      type: Array,
      default: () => []
    },

    /** @type {Array<{value: string, label: string}>} subclassificações da classificação selecionada. */
    subclassificacoes: {
      type: Array,
      default: () => []
    },

    carregandoClassificacoes: {
      type: Boolean,
      default: false
    },

    carregandoSubclassificacoes: {
      type: Boolean,
      default: false
    },

    passoInicial: {
      type: Number,
      default: 0
    },

    veiculoSelecionado: {
      type: Boolean,
      default: true
    },

    bloqueioProgressivo: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      /** @type {Object<string, string>} mensagens de erro por campo. */
      validacao: {},
      passoMobile: 0
    };
  },

  created() {
    const total = this.passosMobile.length;
    const inicial = Number.parseInt(this.passoInicial, 10);
    this.passoMobile = Number.isFinite(inicial)
      ? Math.min(Math.max(inicial, 0), total - 1)
      : 0;
  },

  computed: {
    ativaCampoJustificativaAdesivo() {
      return this.value.adesivo0800?.value === "N";
    },
    /** Fluxo liberado: veículo filtrado e fora do modo visualização. */
    fluxoLiberado() {
      return !!this.veiculoSelecionado && !this.modoVisualizacao;
    },
    /**
     * Ordem visual dos obrigatórios. A justificativa entra na sequência
     * só quando exibida (adesivo 0800 = N).
     */
    sequenciaObrigatoria() {
      const base = [
        "tipoOcorrencia", "classificacao", "subclassificacao",
        "dataOcorrencia", "horaOcorrencia", "municipioUf", "perimetro",
        "usoVeiculo", "condicaoClima", "velocidadeVia", "pavimento",
        "condicaoVia", "descricaoLocal", "partesAvariadas",
        "envolvimentoTerceiros", "adesivo0800", "descricaoOcorrencia",
        "registrouBo"
      ];
      if (this.ativaCampoJustificativaAdesivo) {
        base.splice(base.indexOf("descricaoOcorrencia"), 0, "justificativaAdesivo");
      }
      return base;
    },
    /** Opcionais liberam todos de uma vez após filtrar. */
    camposOpcionais() {
      return ["delegacia", "numeroBo", "contatoTecnico", "informouLocadora"];
    },
      passosMobile() {
      return [
        { titulo: "Classificação", descricao: "Defina o tipo e a criticidade do evento." },
        { titulo: "Local e Momento", descricao: "Registre onde e quando a ocorrência aconteceu." },
        { titulo: "Características da Via", descricao: "Descreva as condições encontradas no local." },
        { titulo: "Informações Complementares", descricao: "Adicione os últimos detalhes antes da revisão." },
        { titulo: "Registro da Ocorrência", descricao: "Informe boletim, contato técnico e locadora." }
      ];
    },

   totalPreenchidos() {
      const v = this.value || {};
      const isPlaceholder = (val) => {
        const s = String(val).trim();
        if (s === "") return true;
        if (/^[-–—/\\|._\s]+$/.test(s)) return true;
        const u = s.toUpperCase();
        return u === "N/A" || u === "NA" || u === "NULL" || u === "NULO" || u === "VAZIO" || u === "INDEFINIDO";
      };
      const temValor = (val) => {
        if (val === null || val === undefined || val === "") return false;
        if (typeof val === "object") {
          const inner = val.value !== undefined ? val.value : val.label;
          if (inner === null || inner === undefined) return false;
          if (isPlaceholder(inner)) return false;
          const lbl = val.label !== undefined ? val.label : null;
          if (lbl !== null && lbl !== undefined && isPlaceholder(lbl) && isPlaceholder(inner)) return false;
          if (typeof inner === "string" && isPlaceholder(inner)) return false;
          return true;
        }
        return !isPlaceholder(val);
      };
      const campos = [
        "tipoOcorrencia", "classificacao", "subclassificacao",
        "dataOcorrencia", "horaOcorrencia", "municipioUf", "perimetro", "usoVeiculo", "condicaoClima",
        "velocidadeVia", "pavimento", "condicaoVia", "descricaoLocal", "partesAvariadas",
        "envolvimentoTerceiros", "adesivo0800", "justificativaAdesivo", "descricaoOcorrencia",
        "registrouBo", "delegacia", "numeroBo", "contatoTecnico", "informouLocadora"
      ];
      const veiculoPreenchido =
        (this.placaSelecionada ? 1 : 0) + (this.projetoSelecionado ? 1 : 0);
      return (
        campos.filter((c) => {
          if (c === "justificativaAdesivo" && !this.ativaCampoJustificativaAdesivo) return false;
          return temValor(v[c]);
        }).length + veiculoPreenchido
      );
    }
  },

  mounted() {
    this.notificarPasso();
  },

  methods: {
    notificarPasso() {
      this.$emit("passo-mobile", {
        indice: this.passoMobile,
        total: this.passosMobile.length
      });
    },

    /** Repassa a placa escolhida para o container controlar a seleção. */
    aoSelecionarPlaca(placa) {
      this.$delete(this.validacao, "placa");
      this.$emit("update:placaSelecionada", placa);
    },

    /** Repassa o projeto escolhido para o container (dispara o filtro). */
    aoSelecionarProjeto(projeto) {
      this.$delete(this.validacao, "projeto");
      this.$emit("update:projetoSelecionado", projeto);
    },

    desabilitarDataFutura(date) {
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return d > hoje;
    },
    temValorPreenchido(val) {
      if (val === null || val === undefined || val === "") return false;
      const isPlaceholder = (s) => {
        const t = String(s).trim();
        if (t === "") return true;
        if (/^[-–—/\\|._\s]+$/.test(t)) return true;
        const u = t.toUpperCase();
        return u === "N/A" || u === "NA" || u === "NULL" || u === "NULO" || u === "VAZIO" || u === "INDEFINIDO";
      };
      if (typeof val === "object") {
        const inner = val.value !== undefined ? val.value : val.label;
        if (inner === null || inner === undefined) return false;
        if (isPlaceholder(inner)) return false;
        if (val.label !== undefined && val.label !== null && isPlaceholder(val.label) && isPlaceholder(inner)) return false;
        return true;
      }
      return !isPlaceholder(val);
    },
    campoHabilitado(campo) {
      if (!this.fluxoLiberado) return false;
      if (!this.bloqueioProgressivo) return true;
      if (this.camposOpcionais.includes(campo)) return true;
      const ordem = this.sequenciaObrigatoria;
      const indice = ordem.indexOf(campo);
      if (indice === -1) return true;
      for (let i = 0; i < indice; i += 1) {
        if (!this.temValorPreenchido(this.value[ordem[i]])) return false;
      }
      return true;
    },
    atualizarCampo(campo, valor) {
      const atualizado = { ...this.value, [campo]: valor };

      if (campo === "tipoOcorrencia") {
        atualizado.classificacao = null;
        atualizado.subclassificacao = null;
      }

      if (campo === "classificacao") {
        atualizado.subclassificacao = null;
        this.$emit("buscar-subclassificacoes", valor);
      }

      if (campo === "adesivo0800" && valor?.value === "S") {
        atualizado.justificativaAdesivo = "";
      }

      this.$emit("input", atualizado);
      if (campo === "tipoOcorrencia") {
        this.$emit("buscar-classificacoes", valor);
      }

      this.validarCampoTempoReal(campo, valor, atualizado);
      if (campo === "tipoOcorrencia") {
        this.$delete(this.validacao, "classificacao");
        this.$delete(this.validacao, "subclassificacao");
      }
      if (campo === "classificacao") {
        this.$delete(this.validacao, "subclassificacao");
      }
      if (campo === "dataOcorrencia" || campo === "horaOcorrencia") {
        this.validarCampoTempoReal(
          campo === "dataOcorrencia" ? "horaOcorrencia" : "dataOcorrencia",
          atualizado[campo === "dataOcorrencia" ? "horaOcorrencia" : "dataOcorrencia"],
          atualizado
        );
      }
      if (campo === "adesivo0800") {
        this.$delete(this.validacao, "justificativaAdesivo");
        if (valor?.value === "N") {
          this.validarCampoTempoReal("justificativaAdesivo", atualizado.justificativaAdesivo, atualizado);
        }
      }
    },

    validarCampoTempoReal(campo, valor, contexto) {
      const ctx = contexto || this.value;
      let erro = null;
      const agora = new Date();
      switch (campo) {
        case "dataOcorrencia":
          erro = validarDataOcorrencia(valor, { hoje: agora });
          break;
        case "horaOcorrencia":
          erro = validarHoraOcorrencia(valor, ctx.dataOcorrencia, { agora });
          break;
        case "velocidadeVia":
          erro = validarVelocidade(valor);
          break;
        case "tipoOcorrencia":
          erro = validarSelectObrigatorio(valor, mensagensDadosOcorrencia.tipoOcorrencia);
          break;
        case "classificacao":
          erro = validarSelectObrigatorio(valor, mensagensDadosOcorrencia.classificacao);
          break;
        case "subclassificacao":
          erro = validarSelectObrigatorio(valor, mensagensDadosOcorrencia.subclassificacao);
          break;
        case "municipioUf":
          erro = validarSelectObrigatorio(valor, mensagensDadosOcorrencia.municipioUf);
          break;
        case "perimetro":
          erro = validarSelectObrigatorio(valor, mensagensDadosOcorrencia.perimetro);
          break;
        case "usoVeiculo":
          erro = validarSelectObrigatorio(valor, mensagensDadosOcorrencia.usoVeiculo);
          break;
        case "condicaoClima":
          erro = validarSelectObrigatorio(valor, mensagensDadosOcorrencia.condicaoClima);
          break;
        case "pavimento":
          erro = validarSelectObrigatorio(valor, mensagensDadosOcorrencia.pavimento);
          break;
        case "condicaoVia":
          erro = validarSelectObrigatorio(valor, mensagensDadosOcorrencia.condicaoVia);
          break;
        case "envolvimentoTerceiros":
          erro = validarSelectObrigatorio(valor, mensagensDadosOcorrencia.envolvimentoTerceiros);
          break;
        case "adesivo0800":
          erro = validarSelectObrigatorio(valor, mensagensDadosOcorrencia.adesivo0800);
          break;
        case "registrouBo":
          erro = validarSelectObrigatorio(valor, mensagensDadosOcorrencia.registrouBo);
          break;
        case "descricaoLocal":
          erro = validarTextoObrigatorio(valor, {
            min: 3,
            max: 200,
            mensagemObrigatorio: mensagensDadosOcorrencia.descricaoLocal,
            mensagemMin: "Descrição do local deve ter ao menos 3 caracteres",
            mensagemMax: "Descrição do local deve ter no máximo 200 caracteres"
          });
          break;
        case "partesAvariadas":
          erro = validarTextoObrigatorio(valor, {
            min: 3,
            max: 4000,
            mensagemObrigatorio: mensagensDadosOcorrencia.partesAvariadas,
            mensagemMin: "Informe ao menos 3 caracteres",
            mensagemMax: "Partes avariadas deve ter no máximo 4000 caracteres"
          });
          break;
        case "descricaoOcorrencia":
          erro = validarTextoObrigatorio(valor, {
            min: 20,
            max: 4000,
            mensagemObrigatorio: mensagensDadosOcorrencia.descricaoOcorrencia,
            mensagemMin: "Descreva a ocorrência com ao menos 20 caracteres",
            mensagemMax: "Descrição deve ter no máximo 4000 caracteres"
          });
          break;
        case "justificativaAdesivo": {
          const adesivoValor = ctx.adesivo0800?.value;
          if (adesivoValor === "N") {
            erro = validarTextoObrigatorio(valor, {
              min: 10,
              max: 200,
              mensagemObrigatorio: "Justifique a ausência do adesivo 0800",
              mensagemMin: "Justificativa deve ter ao menos 10 caracteres",
              mensagemMax: "Justificativa deve ter no máximo 200 caracteres"
            });
          } else {
            this.$delete(this.validacao, campo);
            return;
          }
          break;
        }
        case "delegacia":
          erro = validarTamanhoMaximo(
            valor,
            100,
            "Delegacia deve ter no máximo 100 caracteres"
          );
          break;
        case "numeroBo":
          erro = validarTamanhoMaximo(
            valor,
            30,
            "Número do B.O ou protocolo deve ter no máximo 30 caracteres"
          );
          break;
        default:
          return;
      }
      if (erro) {
        if (!this.validacao[campo] && !valor) {
          return;
        }
        this.$set(this.validacao, campo, erro);
      } else {
        this.$delete(this.validacao, campo);
      }
    },

    bloquearTeclasVelocidade,
    atualizarVelocidade(valor) {
      const sanitizado = sanitizarVelocidade(valor);
      const erro = validarVelocidade(sanitizado);
      if (erro) {
        this.$set(this.validacao, "velocidadeVia", erro);
      } else {
        this.$delete(this.validacao, "velocidadeVia");
      }
      this.atualizarCampo("velocidadeVia", sanitizado);
    },

    salvar() {
      if (this.validar()) {
        this.$emit("salvar", this.value);
      }
    },

    proximaAba() {
      if (this.validar()) {
        this.$emit("proxima");
      }
    },

    validar() {
      if (this.modoVisualizacao) return true;
      const { isValid, erros } = validarDadosOcorrencia(this.value, { agora: new Date() });
      this.validacao = erros;
      const veiculoOk = this.validarVeiculo();
      return veiculoOk && isValid;
    },

    /**
     * Valida os campos obrigatórios de placa/projeto (controlados pelo container)
     * e reflete o resultado em `validacao` para destacar os campos.
     * @returns {boolean} `true` quando placa e projeto estão preenchidos
     */
    validarVeiculo() {
      let ok = true;

      if (!this.placaSelecionada) {
        this.$set(this.validacao, "placa", "Selecione a placa");
        ok = false;
      } else {
        this.$delete(this.validacao, "placa");
      }

      if (!this.projetoSelecionado) {
        this.$set(this.validacao, "projeto", "Selecione o projeto");
        ok = false;
      } else {
        this.$delete(this.validacao, "projeto");
      }

      return ok;
    },

    // ---------------------------------------------------------------
    // Multi-step mobile: navegação por seção (desktop não usa).
    // Valida só os campos do passo atual antes de avançar.
    // ---------------------------------------------------------------
    camposDoPasso(i) {
      const mapa = [
        ["tipoOcorrencia", "classificacao", "subclassificacao"],
        ["dataOcorrencia", "horaOcorrencia", "municipioUf", "perimetro", "usoVeiculo", "condicaoClima"],
        ["velocidadeVia", "pavimento", "condicaoVia", "descricaoLocal", "partesAvariadas"],
        ["envolvimentoTerceiros", "adesivo0800", "justificativaAdesivo", "descricaoOcorrencia"],
        ["registrouBo", "delegacia", "numeroBo", "contatoTecnico", "informouLocadora"]
      ];
      return mapa[i] || [];
    },

    validarPasso(i) {
      if (this.modoVisualizacao) return true;
      const { erros } = validarDadosOcorrencia(this.value, { agora: new Date() });
      const campos = this.camposDoPasso(i);
      let ok = true;
      campos.forEach((campo) => {
        if (erros[campo]) {
          this.$set(this.validacao, campo, erros[campo]);
          ok = false;
        } else {
          this.$delete(this.validacao, campo);
        }
      });
      if (i === 0) {
        const veiculoOk = this.validarVeiculo();
        ok = ok && veiculoOk;
      }
      return ok;
    },

    irParaPasso(i) {
      if (i === this.passoMobile) return;
      if (i > this.passoMobile && !this.modoVisualizacao) {
        for (let p = this.passoMobile; p < i; p += 1) {
          if (!this.validarPasso(p)) {
            this.passoMobile = p;
            this.rolarAoTopoPasso();
            this.notificarPasso();
            return;
          }
        }
      }
      this.passoMobile = i;
      this.rolarAoTopoPasso();
      this.notificarPasso();
    },

    avancarPasso() {
      if (!this.validarPasso(this.passoMobile)) {
        this.rolarAoTopoPasso();
        return;
      }
      if (this.passoMobile < this.passosMobile.length - 1) {
        this.passoMobile += 1;
        this.rolarAoTopoPasso();
        this.notificarPasso();
      }
    },

    voltarPasso() {
      if (this.passoMobile > 0) {
        this.passoMobile -= 1;
        this.rolarAoTopoPasso();
        this.notificarPasso();
      }
    },

    rolarAoTopoPasso() {
      this.$nextTick(() => {
        const el = this.$el && this.$el.querySelector
          ? this.$el.querySelector(".dados-stepper")
          : null;
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/_main";
@import "../../../styles/components/_etapas";
@import "../../../styles/layout/_transitions";
</style>



